import clsx from 'clsx'
import type { PropsWithChildren, ReactElement, ReactNode } from 'react'
import { Paper } from '~/components/Global/Blocks/Paper/Paper'
import { headerFooter, headerInner, headerPaper } from './Header.css'

export const PageHeader = ({
  children,
  footer
}: PropsWithChildren<{ footer?: ReactNode }>): ReactElement => {
  return (
    <Paper className={headerPaper}>
      <header>
        <div className={clsx(headerInner)}>{children}</div>
        {footer && <div className={headerFooter}>{footer}</div>}
      </header>
    </Paper>
  )
}
